import {CasaAIResponse} from '../interfaces/MessageEntity';
import MessageUser from '../interfaces/MessageUser';

export default class Message {
  constructor(public type: MessageUser, public content: CasaAIResponse) {}
}
